import { Directive, ElementRef, HostListener, Renderer2 } from '@angular/core';
import { NgControl, Validators } from '@angular/forms';
import { ISubscription } from 'rxjs/Subscription';
import { formConfigs } from '../../utils/variables.utils';
@Directive({
  selector: '[formControl][appCardMask],[formControlName][appCardMask]',
})
export class CardMaskDirective {
  backspace = false;
  delete = false;
  subscription: ISubscription;
  value = "";
  formConfigs = formConfigs;

  constructor(public ngControl: NgControl, private elementRef: ElementRef<HTMLFormElement>, private renderer: Renderer2) {
    // add this attribute to every credit card number to show the proper max length errors by exluding the space masking characters
    this.renderer.setAttribute(this.elementRef.nativeElement, 'title', 'cardNumberValidation');
  }

  ngOnInit() {
    // setting common min and max length for the credit card across the entire application whichever formcontrol is using the "appCardMask" attribute
    this.ngControl.control.setValidators(this.ngControl.control?.errors?.required ?
      [Validators.required, Validators.minLength(formConfigs.creditCardNumberWithSpaceMask), Validators.maxLength(formConfigs.creditCardNumberWithSpaceMask)] :
      [Validators.minLength(formConfigs.creditCardNumberWithSpaceMask), Validators.maxLength(formConfigs.creditCardNumberWithSpaceMask)]);
    this.onInputChange();
  }

  @HostListener('keydown.backspace', ['$event'])
  keydownBackspace(event) {
    this.backspace = true;
  }

  @HostListener('keydown.delete', ['$event'])
  keydownDelete(event) {
    this.delete = true;
  }

  @HostListener('blur', ['$event'])
  onBlur(event) {
    this.value = event.target.value;
    this.backspace = false;
    this.onAfterValueChanges(this.value);
  }

  @HostListener('input', ['$event'])
  onModelChange(event) {
    this.value = event.target.value;
    this.backspace = false;
  }

  onInputChange() {
    this.subscription = this.ngControl.valueChanges.subscribe(subscribedData => {
      if (!subscribedData) return;
      if (typeof subscribedData === 'string' && subscribedData[0] == '0') {
        subscribedData = subscribedData.slice(1);
      }
      this.onAfterValueChanges(subscribedData);
    });
    this.backspace = false;
    this.delete = false;
  }

  onAfterValueChanges(subscribedData) {
    let data = subscribedData.toString();
    let inputValue: string = this.value;
    var newVal = data.replace(/\D/g, '');
    let start = this.elementRef.nativeElement.selectionStart;
    let end = this.elementRef.nativeElement.selectionEnd;
    if (newVal.length == 0) {
      newVal = '';
    }
    else if (newVal.length <= 4) {
      newVal = newVal.replace(/^(\d{0,4})/, '$1');
    } else if (newVal.length <= 8) {
      newVal = newVal.replace(/^(\d{0,4})(\d{0,4})/, '$1 $2');
    } else if (newVal.length <= 12) {
      newVal = newVal.replace(/^(\d{0,4})(\d{0,4})(\d{0,4})/, '$1 $2 $3');
    } else {
      newVal = newVal.replace(/^(\d{0,4})(\d{0,4})(\d{0,4})(\d{0,4})/, '$1 $2 $3 $4');
    }
    //you are typing in the middle of below logic
    if (inputValue.length >= start) {
      this.ngControl.control.setValue(newVal, { emitEvent: false });
      this.elementRef.nativeElement.setSelectionRange(start, end);
    } else {
      this.ngControl.control.setValue(newVal, { emitEvent: false });
      if (this.backspace) {
        this.elementRef.nativeElement.setSelectionRange(start, end);
      }
      else if (this.delete) {
        this.elementRef.nativeElement.setSelectionRange(start, end);
      }
    }
  }

  ngOnDestroy() {
    if (this.subscription && !this.subscription.closed) {
      this.subscription.unsubscribe();
    }
  }
}